export class EoProgressComments {
  id: number;
  modAbbreviation: string;
  modNumber: string;
  enteredAt: Date;
  enteredBy: string;
  commments: string;
}
